import { MarketplaceAffiliateJoinedInfluencer, MarketplaceCampaignRevenueType } from '@anytag/graphql';

export const getRevenueItems = (revenueItems: MarketplaceAffiliateJoinedInfluencer['revenueItems']) => ({
  revenuePerAction: findRevenueByType(revenueItems, MarketplaceCampaignRevenueType.REVENUE_PER_ACTION),
  revenuePerClick: findRevenueByType(revenueItems, MarketplaceCampaignRevenueType.REVENUE_PER_CLICK),
  revenuePerComment: findRevenueByType(revenueItems, MarketplaceCampaignRevenueType.REVENUE_PER_COMMENT),
  revenuePerLike: findRevenueByType(revenueItems, MarketplaceCampaignRevenueType.REVENUE_PER_LIKE),
  revenuePerPost: findRevenueByType(revenueItems, MarketplaceCampaignRevenueType.REVENUE_PER_POST),
  revenuePerShare: findRevenueByType(revenueItems, MarketplaceCampaignRevenueType.REVENUE_PER_SHARE),
  revenuePerView: findRevenueByType(revenueItems, MarketplaceCampaignRevenueType.REVENUE_PER_VIEW),
  influencerCommissionRate: findRevenueByType(revenueItems, MarketplaceCampaignRevenueType.INFLUENCER_COMMISSION_RATE)
});

export const findRevenueByType = (
  revenueItems: MarketplaceAffiliateJoinedInfluencer['revenueItems'],
  revenueType: MarketplaceCampaignRevenueType
) => revenueItems.find((item) => item.revenueType === revenueType);
